import { Add as CatalogAdd } from './Add';

export default CatalogAdd;
